export default {
  common: {
    confirmTitle: '系统提示',
    delMessage: '是否删除所选中数据？',
    delSuccess: '删除成功',
    save: '保存',
    cancel: '取消',
    confirm: '确定',
    reload: '重新加载',
    loginOut: '退出登录',
    profile: '个人中心',
    reset: '重置',
    updateSuccess: '更新成功',
    yes: '是',
    no: '否'
  },
  router: {
    home: '首页',
    login: '登录'
  },
  permission: {
    hasPermission: `请设置操作权限标签值`,
    hasRole: `请设置角色权限标签值`
  },
  login: {
    title: '后台管理系统',
    username: '账号',
    password: '密码',
    login: '登 录',
    usernamePlaceholder: '请输入账号',
    passwordPlaceholder: '请输入密码',
    loginSuccess: '登录成功',
    relogin: '重新登录'
  },
  profile: {
    user: {
      title: '个人信息',
      username: '用户名称',
      nickname: '用户昵称',
      mobile: '手机号码',
      email: '用户邮箱',
      dept: '所属部门',
      posts: '所属岗位',
      roles: '所属角色',
      sex: '性别',
      man: '男',
      woman: '女',
      createTime: '创建日期',
      version: '版本号'
    },
    info: {
      title: '基本信息',
      basicInfo: '基本设置',
      resetPwd: '密码设置',
      userSocial: '社交绑定',
      processInfo: '流程信息'
    },
    rules: {
      nickname: '请输入用户昵称',
      mail: '请输入邮箱地址',
      truemail: '请输入正确的邮箱地址',
      phone: '请输入正确的手机号码',
      truephone: '请输入正确的手机号码'
    },
    password: {
      oldPassword: '旧密码',
      newPassword: '新密码',
      confirmPassword: '确认密码',
      oldPwdMsg: '请输入旧密码',
      newPwdMsg: '请输入新密码',
      cfPwdMsg: '请输入确认密码',
      pwdRules: '长度在 6 到 20 个字符',
      diffPwd: '两次输入密码不一致'
    }
  },
  sys: {
    api: {
      operationFailed: '操作失败',
      errorMessage: '网络连接异常，请检查您的网络',
      apiTimeoutMessage: '接口请求超时，请刷新页面重试',
      apiRequestFailed: '请求出错，请稍候重试',
      errMsg500: '系统异常，请稍后重试'
    }
  }
}
